import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoMetricsReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_metrics" />
);

export default KlaviyoMetricsReport;
